import { Box, Text, Select, Spinner, Button } from 'grommet';
import { useAppSelector } from '../../../../redux';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { downloadClassificationData, generateLayers, setClassificationLayer } from '../../../../redux/actions/map-actions/field/field-action';
import { ClassificationLayersStatus, LayerOption } from '../../../../service/common/constants';
import { useParams } from 'react-router-dom';
import { StyledTooltip } from '../../../../components/common/StyledTooltip';
import { toggleRemove } from '../../../../redux/actions/map-actions/map-action';

const defaultOptions: LayerOption[] = [
  { label: 'Classified', value: 'classified' },
  { label: 'ESA land cover', value: 'esa_landcover' },
  { label: 'CDL 2021', value: 'cdl_landcover' },
  { label: 'Composite DW', value: 'classified_dw' },
  { label: 'Cluster Hull - Trees', value: 'hull-Tree-clustered' },
];

export const LayerSelector = (): JSX.Element => {
  const { journeyId } = useParams();
  const dispatch = useDispatch();
  const layers = useAppSelector((state) => state.map.classificationLayers);
  const status = useAppSelector((state) => state.map.classificationState);
  const selected = useAppSelector((state) => state.map.classificationLayer);
  const trainingRegions = useAppSelector((state) => state.map.trainingRegions);
  const trainingRegionsTouched = useAppSelector((state) => state.map.trainingRegionsTouched);
  const [options, setOptions] = useState<LayerOption[]>([]);
  const [missingTrainingWarning, setMissingTrainingWarning] = useState<string[]>([]);
  useEffect(() => {
    dispatch(toggleRemove(false));
  }, []);

  useEffect(() => {
    const classes = {
      1: 'Tree',
      2: 'Barren',
      3: 'Grass',
    };
    const missingWarnings: string[] = [];
    for (const c of Object.keys(classes)) {
      if (!trainingRegions.find((region) => region?.properties?.class == Number(c))) {
        missingWarnings.push(classes[c]);
      }
    }
    console.log(missingWarnings);
    setMissingTrainingWarning(missingWarnings);
  }, [trainingRegions]);

  useEffect(() => {
    console.log(layers);
    const newOptions: LayerOption[] = [];
    if (!layers) return;
    layers;
    for (const layer of defaultOptions) {
      if (!layers[layer.value]) continue;
      newOptions.push(layer);
    }
    setOptions(newOptions);
  }, [layers]);

  const components = {
    [ClassificationLayersStatus.UNAVAILABLE]: <Text style={{ fontSize: '12px', fontWeight: 700 }}>No Classification Layer available</Text>,
    [ClassificationLayersStatus.LOADING]: (
      <Box direction={'row'} gap={'small'} align={'center'}>
        <Text style={{ fontSize: '12px', fontWeight: 700 }}>Loading layers </Text>
        <Spinner />
      </Box>
    ),
    [ClassificationLayersStatus.GENERATING]: (
      <Box direction={'row'} gap={'small'} align={'center'}>
        <Text style={{ fontSize: '12px', fontWeight: 700 }}>Generating layers </Text>
        <Spinner />
      </Box>
    ),
    [ClassificationLayersStatus.ERROR]: <Text style={{ fontSize: '12px', fontWeight: 700 }}>Error loading layers</Text>,
    [ClassificationLayersStatus.SUCCESS]: (
      <Select
        placeholder={'Select Layer'}
        clear={true}
        width={'100%'}
        options={options}
        onChange={(type) => {
          // setSelected(type.option)
          dispatch(setClassificationLayer(type.option));
        }}
        value={selected}
      />
    ),
  };

  const buttonLabel = {
    [ClassificationLayersStatus.UNAVAILABLE]: 'Generate Layers',
    [ClassificationLayersStatus.LOADING]: 'Loading',
    [ClassificationLayersStatus.GENERATING]: 'Generating',
    [ClassificationLayersStatus.ERROR]: 'Retry',
    [ClassificationLayersStatus.SUCCESS]: 'Re-generate',
  };

  return (
    <Box
      direction={'row'}
      gap={'small'}
      style={{
        // position: 'absolute',
        bottom: '24px',
        left: '24px',
        padding: '7px 7px',
        // height: '10rem',
        minWidth: '20rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 130,
        background: '#fff',
        border: 'solid 1px #282828',
        borderRadius: '5px',
      }}>
      <Box align='center'>{components[status] || <Text style={{ fontSize: '12px', fontWeight: 700 }}>No Classification Layer available</Text>}</Box>
      {buttonLabel[status] && (
        <Box direction={'row'} align={'center'} gap={'small'} height={'100%'}>
          <StyledTooltip
            dropOptions={'top'}
            showToolTip={missingTrainingWarning.length > 0}
            label={`
          Missing training region for: ${missingTrainingWarning.length ? missingTrainingWarning.join(', ') : 'None'}
        `}>
            <Box height={'100%'}>
              <Button
                key={'Download Vectors'}
                style={{
                  display: 'flex',
                  height: '100%',
                  padding: '0px 4px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '8px',
                  background: '#FFE137',
                  fontWeight: 900,
                  lineHeight: '14px',
                  letterSpacing: '0.84px',
                  fontSize: '12px',
                  width: '170px',
                }}
                disabled={
                  !!missingTrainingWarning.length ||
                  !status ||
                  [ClassificationLayersStatus.LOADING, ClassificationLayersStatus.GENERATING].includes(status)
                }
                onClick={() => {
                  dispatch(generateLayers(journeyId, trainingRegionsTouched ? trainingRegions : undefined));
                }}>
                {buttonLabel[status] ?? 'Loading'}
              </Button>
            </Box>
          </StyledTooltip>
          <Box height={'100%'}>
            <Button
              key={'Download Vectors'}
              style={{
                display: 'flex',
                height: '100%',
                padding: '0px 4px',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '8px',
                background: '#FFE137',
                fontWeight: 900,
                lineHeight: '14px',
                letterSpacing: '0.84px',
                fontSize: '12px',
                width: '170px',
              }}
              disabled={
                !!missingTrainingWarning.length ||
                !status ||
                [ClassificationLayersStatus.LOADING, ClassificationLayersStatus.GENERATING].includes(status)
              }
              onClick={() => {
                dispatch(downloadClassificationData(journeyId, layers));
              }}>
              {'Download'}
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};
